enum StoryAction {
  'ARCHIVE' = 'archive',
  'DELETE' = 'delete',
  'EDIT' = 'edit',
  'VIEW' = 'view',
  'UNZIP' = 'unzip'
}

export {StoryAction}
